import { isCcEmailFormat, mergeCcEmails, normalizeCcEmail } from "./ccEmails.js";

export type MfgVendorExtraContact = {
  name: string;
  email: string;
};

export function emptyVendorExtraContact(): MfgVendorExtraContact {
  return { name: "", email: "" };
}

export function extraContactEmails(
  contacts: readonly MfgVendorExtraContact[] | undefined
): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const c of contacts ?? []) {
    const email = normalizeCcEmail(c.email ?? "");
    if (!email || seen.has(email)) continue;
    seen.add(email);
    out.push(email);
  }
  return out;
}

export function mergeExtraContactEmails(
  current: readonly string[],
  contacts: readonly MfgVendorExtraContact[] | undefined
): string[] {
  return mergeCcEmails(current, extraContactEmails(contacts));
}

export function parseVendorExtraContacts(raw: unknown):
  | { ok: true; contacts: MfgVendorExtraContact[] }
  | { ok: false; error: string } {
  if (raw == null || raw === "") return { ok: true, contacts: [] };
  if (typeof raw === "string") {
    try {
      return parseVendorExtraContacts(JSON.parse(raw));
    } catch {
      return { ok: false, error: "Extra contacts must be a list of name and email rows." };
    }
  }
  if (!Array.isArray(raw)) {
    return { ok: false, error: "Extra contacts must be a list of name and email rows." };
  }
  const contacts: MfgVendorExtraContact[] = [];
  for (let i = 0; i < raw.length; i++) {
    const row = (raw[i] ?? {}) as Record<string, unknown>;
    const name = typeof row.name === "string" ? row.name.trim() : "";
    const email = typeof row.email === "string" ? row.email.trim() : "";
    if (!name && !email) continue;
    if (!email) {
      return { ok: false, error: `Extra contact ${i + 1} needs an email.` };
    }
    if (!isCcEmailFormat(email)) {
      return { ok: false, error: `"${email}" is not a valid extra-contact email.` };
    }
    contacts.push({ name, email: normalizeCcEmail(email) });
  }
  return { ok: true, contacts };
}
